import { render } from "./microWebsiteShare.vue?vue&type=template&id=8962b568&scoped=true"
import script from "./microWebsiteShare.vue?vue&type=script&lang=js"
export * from "./microWebsiteShare.vue?vue&type=script&lang=js"

import "./microWebsiteShare.vue?vue&type=style&index=0&id=8962b568&lang=scss"
import "./microWebsiteShare.vue?vue&type=style&index=1&id=8962b568&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8962b568"]])

export default __exports__